<main @fade>
  <nb-card>
    <nb-card-body>
      <div class="row" [nbSpinner]="loading">
        <div [ngClass]="fieldsFeatures && fieldsFeatures.length && this.showDamFilter ? 'col-10' : 'col-12'">
          <div class="mb-1 pb-2">
            <app-basket-info></app-basket-info>
          </div>
          <app-basket-table [productList]="data"
                            [catalogBreadCrumbs]="catalogBreadCrumbs"
                            [catalogId]="menuId"
                            [configURI]="'cabinet/dam/basket'"
          >
          </app-basket-table>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</main>
